import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "invoice-payment-form" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", null, "Registrer innbetaling", -1)
const _hoisted_3 = { class: "field" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Dato", -1)
const _hoisted_5 = { class: "field-error" }
const _hoisted_6 = { class: "field" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Beløp", -1)
const _hoisted_8 = { class: "field__input" }
const _hoisted_9 = { class: "field-error" }
const _hoisted_10 = { class: "is-complete" }
const _hoisted_11 = { class: "label" }
const _hoisted_12 = { class: "buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    onDismiss: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('dismiss'))),
    "with-card": true
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", _hoisted_1, [
        _createElementVNode("header", null, [
          _hoisted_2,
          _createVNode(_component_SvgIcon, {
            class: "close-icon",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('dismiss'))),
            type: "mdi",
            path: _ctx.closeIcon
          }, null, 8, ["path"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _withDirectives(_createElementVNode("input", {
            type: "date",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.date) = $event))
          }, null, 512), [
            [_vModelText, _ctx.form.date]
          ]),
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.form.errors.date), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _withDirectives(_createElementVNode("input", {
              type: "number",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.amount) = $event))
            }, null, 512), [
              [_vModelText, _ctx.form.amount]
            ])
          ]),
          _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.form.errors.amount), 1)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("label", _hoisted_11, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.complete) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.form.complete]
            ]),
            _createTextVNode(" Komplett betaling ")
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_Button, {
            onClick: _ctx.sendForm,
            disabled: _ctx.form.processing,
            class: "send-button",
            color: "green"
          }, {
            default: _withCtx(() => [
              (_ctx.form.processing)
                ? (_openBlock(), _createBlock(_component_SvgIcon, {
                    key: 0,
                    class: "animate-spin",
                    type: "mdi",
                    path: _ctx.loadingIcon
                  }, null, 8, ["path"]))
                : _createCommentVNode("", true),
              _createTextVNode("Registrer ")
            ]),
            _: 1
          }, 8, ["onClick", "disabled"]),
          _createVNode(_component_Button, {
            color: "gray",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('dismiss')))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Avbryt")
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }))
}